import { useRef } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Paperclip, Trash2, Download } from "lucide-react";
import { lcall } from "@/lib/letters";
import { downloadBlob } from "@/lib/vi";

const ACCEPT = ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png";

export default function Attachments({ letter, canEdit, onChange }) {
  const ref = useRef();
  const upload = async (e) => {
    const files = [...(e.target.files || [])];
    e.target.value = "";
    for (const f of files) {
      const fd = new FormData(); fd.append("file", f);
      await lcall(() => api.post(`/letters/${letter.id}/attachments`, fd), `« ${f.name} » ajouté`);
    }
    onChange();
  };
  const del = async (a) => { if (window.confirm(`Retirer « ${a.nom} » ?`) && await lcall(() => api.delete(`/letters/${letter.id}/attachments/${a.id}`))) onChange(); };
  const atts = letter.attachments || [];
  return (
    <div data-testid="letter-attachments">
      <p className="text-sm font-semibold flex items-center gap-1.5 mb-2"><Paperclip className="h-4 w-4" />Pièces jointes ({atts.length})</p>
      {!letter.id && <p className="text-xs text-slate-400">Enregistrez le courrier pour ajouter des pièces jointes.</p>}
      <ul className="space-y-1">
        {atts.map((a) => (
          <li key={a.id} className="flex items-center gap-1 text-xs rounded border bg-white px-2 py-1">
            <span className="flex-1 truncate" title={a.nom}>{a.nom}</span>
            <button type="button" onClick={() => downloadBlob(`/letters/${letter.id}/attachments/${a.id}`, a.nom)} className="p-1 hover:text-brand-700" data-testid={`att-dl-${a.id}`}><Download className="h-3.5 w-3.5" /></button>
            {canEdit && <button type="button" onClick={() => del(a)} className="p-1 hover:text-rose-600" data-testid={`att-del-${a.id}`}><Trash2 className="h-3.5 w-3.5" /></button>}
          </li>
        ))}
      </ul>
      {letter.id && canEdit && <>
        <Button type="button" size="sm" variant="outline" className="mt-2 w-full" onClick={() => ref.current?.click()} data-testid="att-add"><Paperclip className="h-3.5 w-3.5 mr-1" />Ajouter des fichiers</Button>
        <input ref={ref} type="file" multiple accept={ACCEPT} className="hidden" onChange={upload} data-testid="att-input" />
        <p className="text-[10px] text-slate-400 mt-1">PDF, DOC, DOCX, XLS, XLSX, JPG, PNG — 15 Mo max</p>
      </>}
    </div>
  );
}
